<style scoped>
	div{box-sizing: border-box;}
	.dalaiBox{ width: 100%;display: flex;flex-direction: row;flex-wrap: wrap;padding: 40px;box-sizing: border-box;}
	.dalaiBox_item{ width: 14.28%;}
	.dalaiBox_item img{ width: 70%;margin: auto;border-radius: 50%;display: block;cursor: pointer;}
	.title{background-image: url(../../../../public/icon/001.png);background-size: cover; background-repeat: no-repeat;height: 50px;color: #fff;text-align: center;line-height: 50px;width: 150px;margin-top: 20px;}
	.userName{ text-align: center;width: 100%;padding: 20px;margin-bottom: 15px;}

</style>
<template>
	<div class="template" style="padding: 30px 60px;">
		<div class="title">{{type}}</div>
		<div class="dalaiBox">
			<div class="dalaiBox_item" v-for="ai in dataList" @click="usersWorks(ai)">
				<img :src="ai.headimg?imgAPI+ai.headimg:require('../../../../public/icon/001.jpg')" />
				<div class="userName">{{ai.nickname?ai.nickname:ai.name}}</div>
			</div>
			<img style="display: block;margin:30px auto;width: 200px;" v-if="dataList.length<1" src="../../../../public/img/74ebae016998d5fae28c89076ff97744.png"/>
		</div>
	</div>
</template>

<script>
	import baseConst from '../../../assets/js/baseConst.js' //注意路
	export default {
		data() {
			return {
				type: '',
				dataList: [],
				pTotla: 0,
				imgAPI: '',
			}
		},
		created: function() {
			let _this = this;
			_this.type = _this.$route.query.type;
			_this.imgAPI = baseConst.IMG_API;
			_this.getDesignLise();

		},
		mounted: function() {
			let _this = this;
		},
		methods: {
			/*获取设计案例
			 创建于2019-11-25  作者：郑凯*/
			getDesignLise() {
				let _this = this;
				let apiUrl = "";
				if(_this.type === '专家资源') {
					apiUrl = '/api/getExperts';
				} else if(_this.type === '设计师') {
					apiUrl = '/api/getDesignGroupList';
				} else { //设计机构
					apiUrl = '/api/getDesignOrg';
				}
				let params = {
					limit: 2000,
					pageNumber: 1
				};
				_this.getApi(apiUrl, params)
					.then((res) => {
						//console.log(res)
						if(res.status == '00') {
							_this.dataList = res.data;
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/*查看设计师的作品
			 创建于2019-11-25  作者：郑凯*/
			usersWorks(ob) {
				let _this = this;
				if(_this.type === '设计机构') {
					_this.$router.push({
						name: 'disgnJigou',
						　　　　query: {
							pagePrams: JSON.stringify(ob)
						}
					})
				} else {
					_this.$router.push({
						name: 'works_user',
						　　　　query: {
							pagePrams: JSON.stringify(ob)
						}
					})
				}

			},
		}
	}
</script>